import {
  ShieldCheckIcon,
  CursorArrowRaysIcon,
  ScaleIcon,
} from "@heroicons/react/20/solid";

export default function PuntiDiForza({ i3Titolo, i3Icone, i3Button }) {
  const primaryFeatures = [
    {
      name: "Robustezza senza compromessi",
      description:
        "Progettato per resistere a carichi pesanti e a condizioni di lavoro impegnative",
      icon: ShieldCheckIcon,
    },
    {
      name: "Precisione e maneggevolezza",
      description:
        "Progettato per resistere a carichi pesanti e a condizioni di lavoro impegnative",
      icon: CursorArrowRaysIcon,
    },
    {
      name: "Risparmio e qualità",
      description:
        "La migliore soluzione per ottimizzare la tua logistica senza compromettere la qualità",
      icon: ScaleIcon,
    },
  ];
  return (
    <div className="mx-auto h-full flex items-center">
      <div className="relative isolate overflow-hidden sm:rounded-3xl w-full">
        <div className="align-middle mx-auto grid max-w-2xl grid-cols-1 gap-x-8 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-center lg:gap-y-0 text-left">
          <div className="flex flex-col justify-center lg:px-40 px-10 lg:py-10 py-8">
            <div>
              <h2
                data-aos="zoom-in-up"
                data-aos-delay={300}
                className="text-3xl font-bold tracking-tight text-giallomoretti sm:text-6xl"
              >
                ESPLORA F4
              </h2>
              <p className="pt-12 text-2xl leading-9">
                L'F4 è progettato come un carrello elevatore a pallet da
                tuttofare che combina forza, flessibilità e compattezza. Con una
                capacità di carico di 1,5 tonnellate, batterie Li-ion rimovibili
                e un peso leggero di 120 kg, l'F4 si adatta facilmente sia ad
                applicazioni occasionali che intensive. Le sue ruote
                stabilizzanti opzionali e le dimensioni delle forche
                personalizzabili lo rendono una scelta davvero versatile per
                diversi settori.
              </p>
            </div>
          </div>
          <img
            alt="Transpallet elettrico F4"
            data-aos="zoom-in-up"
            src="images/f4.webp"
            width="690"
            height="640"
            loading="auto"
            className="relative -z-20 min-w-full max-w-xl lg:w-[32rem] lg:max-w-none"
          />
        </div>
      </div>
    </div>
  );
}
